import React, {useEffect, useState} from "react";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import TextField from "@material-ui/core/TextField";
import "../../assets/scss/Static.scss";
import {getLabel} from "../../localization/MainLocalization";
import {httpRequestWithAuth} from "../../auth/axios_instance";
import {BaseFinanceExpenseListAllURL} from "../../urls";

export const  ExpenseAutoComplete = props=> {
    const [options, setOptions] = useState([])

    useEffect(()=>{
        const fetchData = async ()=>{
            let params = {};

            if (props.full_paid){
                params['is_full_paid'] = props.full_paid
            }

            if (props.vendor){
                params['vendor'] = props.vendor
            }

            let response = await httpRequestWithAuth(BaseFinanceExpenseListAllURL, "GET", null, params);
            if (response.status){
                setOptions(response.data);
            }else{
                setOptions([])
            }
        }

        fetchData();
    },[])

    const handleOnChange = (event, value) => {
        if (!props.viewOnly){
        value = value !== null ? props.fullObject?value: value.id : "";
        props.onChangeHandle(props.name, value);
        }

    };

    const handleAutoCompleteValue = () => {
        let value = null;

            options.map(Data => {
                if (Data.id === props.value) {
                    value = Data;
                }
                return 0;
            });

        return value;
    };


        return (
            <Autocomplete
                ListboxProps={{className:"list-box-autocomplete"}}
                renderOption={(option) => (
                    <span className="w-100 text-start">{`${option.invoice_id} - ${option.title}`}</span>
                )}
                disabled={props.disabled || props.viewOnly}
                options={options}
                getOptionLabel={option => `${option.invoice_id} - ${option.title}`}
                renderInput={params => (
                    <TextField variant="outlined" {...params}
                               label={<label>{getLabel(props.label)}<span
                                   className='text-danger'>{props.required ? "*" : ""}</span></label>}
                               helperText={props.helper_text}
                               error={props.error}
                               fullWidth
                               disabled={props.disabled}
                               className={props.disabled ? "disabled-field" : ""}
                    />
                )}
                value={handleAutoCompleteValue()}
                onChange={handleOnChange}
            />
        );
}
